/**
 * Copyright IBM Corp. 2022, 2026
 */

import {
	ProductLogo as MDSProductLogo,
	normalizeProductLogoProps,
} from '@hashicorp/mds-react/patterns'
import { vercelSplit } from '@web/cms'
import type { ProductLogoFieldsFragment } from 'types/dato'

export const normalizeDatoProductLogo = (props: ProductLogoFieldsFragment) => {
	return normalizeProductLogoProps.with({
		transform: vercelSplit,
	})({
		color: props.color,
		product: props.product,
		size: props.size,
	})
}

export const ProductLogo = (props: ProductLogoFieldsFragment) => {
	return <MDSProductLogo {...normalizeDatoProductLogo(props)} />
}
